import { useEffect, useState } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import Typography from "@mui/material/Typography";

const WelcomeName = () => {
    const { accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [name, setName] = useState("");
    const [provider, setProvider] = useState("");
    useEffect(() => {
        if (account && account.name) {
            if(account.tenantId=="52270bb2-ed98-4b79-9314-1af808682b4b"){
                setProvider("Entra External ID");
            }else{
                setProvider("Legacy>Azure AD B2C");
            }
            setName(account.name.split(" ")[0]);
        } else {
            setName("");
        }
    }, [account]);

    if (name) {
        return <Typography variant="h6">IdP: {provider} | Welcome, {name}</Typography>;
    } else {
        return null;
    }
};

export default WelcomeName;